import {createApi, createApiClient} from "@3dcalc/3dpClient";
import {initParam} from "../setting/initParam";

const client = createApiClient({
    apiUrl: 'https://3dpapi.deallog.pro/api/v1',
    apiKey: '292a2d827b1f03cbad2555d4df4c97828b8f7cec484bffba16f5f0558afc2ca7',
    calculatorId: 'bf4d2b1a-f88d-4322-9ec5-efb088e08c04',
    onError: (error) => {
        console.error('API Error:', error);
    },
    onUnauthorized: () => {
        console.error('Unauthorized! Check your API key');
    }
});

const { config } = await client.init();
Object.assign(initParam, config);

export const api = createApi(client);
